{
  "PROFILE_SETTINGS": {
    "LINK": "Ajustes del perfil",
    "TITLE": "Ajustes del perfil",
    "BTN_TEXT": "Actualizar perfil",
    "DELETE_AVATAR": "Eliminar avatar",
    "AVATAR_DELETE_SUCCESS": "El avatar se ha eliminado correctamente",
    "AVATAR_DELETE_FAILED": "Se ha producido un error al eliminar el avatar, inténtelo de nuevo",
    "UPDATE_SUCCESS": "Tu perfil se ha actualizado correctamente",
    "PASSWORD_UPDATE_SUCCESS": "Su contraseña se ha cambiado correctamente",
    "AFTER_EMAIL_CHANGED": "Su perfil ha sido actualizado con éxito, por favor inicie sesión de nuevo cuando sus credenciales de inicio de sesión se hayan cambiado",
    "FORM": {
      "PICTURE": "Foto de perfil",
      "AVATAR": "Imagen de perfil",
      "ERROR": "Por favor, corrija los errores de formulario",
      "REMOVE_IMAGE": "Eliminar",
      "UPLOAD_IMAGE": "Subir imagen",
      "UPDATE_IMAGE": "Actualizar imagen",
      "PROFILE_SECTION": {
        "TITLE": "Perfil",
        "NOTE": "Su dirección de correo electrónico es su identidad y se utiliza para iniciar sesión."
      },
      "SEND_MESSAGE": {
        "TITLE": "Tecla rápida para enviar mensajes",
        "NOTE": "Puede seleccionar una tecla de acceso rápido (Enter o Cmd/Ctrl+Enter) basándose en su preferencia de escritura.",
        "UPDATE_SUCCESS": "Su configuración se ha actualizado correctamente",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Envía mensajes presionando la tecla Intro en lugar de hacer clic en el botón Enviar."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Envía mensajes pulsando Cmd/Ctrl + tecla Intro en lugar de hacer clic en el botón Enviar."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Customize the look and feel of your Chatwoot dashboard.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Predeterminado",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "LANGUAGE": {
          "TITLE": "Preferred Language",
          "NOTE": "Choose the language you want to use.",
          "UPDATE_SUCCESS": "Your Language settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the language settings, please try again",
          "USE_ACCOUNT_DEFAULT": "Use account default"
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Firma de mensaje personal",
        "NOTE": "Crea una firma de mensaje única para que aparezca al final de cada mensaje que envíes desde cualquier bandeja de entrada. También puede incluir una imagen en línea, que es soportada en las bandejas de entrada de live-chat, correo electrónico y API.",
        "BTN_TEXT": "Guardar firma de mensaje",
        "API_ERROR": "¡No se pudo guardar la firma! Inténtalo de nuevo",
        "API_SUCCESS": "Firma guardada correctamente",
        "IMAGE_UPLOAD_ERROR": "¡No se pudo subir la imagen! Intente nuevamente",
        "IMAGE_UPLOAD_SUCCESS": "Imagen agregada satisfactoriamente. Por favor haga clic en salvar para guardar la firma",
        "IMAGE_UPLOAD_SIZE_ERROR": "El tamaño de la imagen debe ser menor que {size}MB",
        "INLINE_IMAGE_WARNING": "Pasted inline images were removed. Please use the image upload button to add images to your signature."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Firma del mensaje",
        "ERROR": "La firma del mensaje no puede estar vacía",
        "PLACEHOLDER": "Introduzca aquí su firma de mensaje personal."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Contraseña",
        "NOTE": "Actualizar tu contraseña restablecería tus entradas en varios dispositivos.",
        "BTN_TEXT": "Cambiar contraseña"
      },
      "SECURITY_SECTION": {
        "TITLE": "Security",
        "NOTE": "Manage additional security features for your account.",
        "MFA_BUTTON": "Manage Two-Factor Authentication"
      },
      "SESSIONS_SECTION": {
        "TITLE": "Sesiones activas",
        "NOTE": "Estos son los dispositivos conectados actualmente a tu cuenta.",
        "CURRENT": "Sesión actual",
        "REVOKE": "Revocar",
        "REVOKE_SUCCESS": "Sesión revocada con éxito",
        "REVOKE_ERROR": "No se puede revocar la sesión. Por favor, inténtalo de nuevo.",
        "FETCH_ERROR": "No se pueden recuperar las sesiones. Por favor, inténtalo de nuevo.",
        "LAST_ACTIVE": "Última actividad",
        "UNKNOWN_DEVICE": "Dispositivo desconocido"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Token de acceso",
        "NOTE": "Este token puede ser usado si estás construyendo una integración basada en API",
        "PAID_PLAN_NOTE": "Los tokens de acceso API están disponibles en planes de pago.",
        "COPY": "Copiar",
        "RESET": "Reset",
        "CONFIRM_RESET": "¿Está seguro?",
        "CONFIRM_HINT": "Haz clic de nuevo para confirmar",
        "RESET_SUCCESS": "Token de acceso regenerado con éxito",
        "RESET_ERROR": "No se puede regenerar el token de acceso. Por favor, inténtalo de nuevo"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Alertas de audio",
        "NOTE": "Active las notificaciones de sonido en el tablero para los mensajes nuevos y conversaciones.",
        "PLAY": "Reproducir sonido",
        "ALERT_TYPES": {
          "NONE": "Ninguna",
          "MINE": "Asignado",
          "ALL": "Todos",
          "ASSIGNED": "Conversaciones asignadas",
          "UNASSIGNED": "Conversaciones sin asignar",
          "NOTME": "Conversaciones abiertas asignadas a otros"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "No ha seleccionado ninguna opción, no recibirá ninguna alerta de audio.",
          "ASSIGNED": "Recibirás alertas sobre las conversaciones que se te hayan asignado.",
          "UNASSIGNED": "Recibirás alertas sobre cualquier conversación no asignada.",
          "NOTME": "Recibirás alertas sobre las conversaciones asignadas a otros.",
          "ASSIGNED+UNASSIGNED": "Recibirás alertas de tus conversaciones asignadas y de las no atendidas.",
          "ASSIGNED+NOTME": "Recibirás alertas sobre las conversaciones que te han sido asignadas a ti y a otros, pero no sobre las no asignadas.",
          "NOTME+UNASSIGNED": "Recibirás alertas de conversaciones desatendidas y de las asignadas a otros.",
          "ASSIGNED+NOTME+UNASSIGNED": "Recibirás alertas de todas las conversaciones."
        },
        "ALERT_TYPE": {
          "TITLE": "Eventos de alerta para conversaciones",
          "NONE": "Ninguna",
          "ASSIGNED": "Conversaciones asignadas",
          "ALL_CONVERSATIONS": "Todas las conversaciones"
        },
        "DEFAULT_TONE": {
          "TITLE": "Tono de alerta:"
        },
        "CONDITIONS": {
          "TITLE": "Condiciones de alerta:",
          "CONDITION_ONE": "Enviar alertas de audio sólo si la ventana del navegador no está activa",
          "CONDITION_TWO": "Enviar alertas cada 30s hasta que todas las conversaciones asignadas sean leídas"
        },
        "SOUND_PERMISSION_ERROR": "La reproducción automática está desactivada en su navegador. Para escuchar las alertas automáticamente, habilite el permiso de sonido en la configuración de su navegador o interactúe con la página.",
        "READ_MORE": "Leer más"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Notificaciones por email",
        "NOTE": "Actualiza tus preferencias de notificación por correo electrónico aquí",
        "CONVERSATION_ASSIGNMENT": "Enviar notificaciones por correo electrónico cuando se me ha asignado una conversación",
        "CONVERSATION_CREATION": "Enviar notificaciones por correo electrónico cuando se crea una nueva conversación",
        "CONVERSATION_MENTION": "Enviar notificaciones por correo electrónico cuando sea mencionado en una conversación",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Envirar notificaciones por correo electrónico cuando un nuevo mensaje es creado en una conversación asignada",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Enviar notificaciones por correo electrónico cuando se crea un nuevo mensaje en una conversación participante",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Preferencias de notificación",
        "TYPE_TITLE": "Tipo de notificación",
        "EMAIL": "E-mail",
        "PUSH": "Notificación push",
        "TYPES": {
          "CONVERSATION_CREATED": "Se ha creado una nueva conversación",
          "CONVERSATION_ASSIGNED": "Se te ha asignado una conversación",
          "CONVERSATION_MENTION": "Has sido mencionado en una conversación",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Un nuevo mensaje se ha creado en una conversación asignada",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Un nuevo mensaje se ha creado en una conversación en la que participas",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "Una conversación carece de resolución SLA"
        },
        "BROWSER_PERMISSION": "Activa las notificaciones push en tu navegador para que puedas recibirlas"
      },
      "API": {
        "UPDATE_SUCCESS": "Sus preferencias de notificación se actualizaron correctamente",
        "UPDATE_ERROR": "Se ha producido un error al actualizar las preferencias, inténtelo de nuevo"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Notificaciones push",
        "NOTE": "Actualize sus preferencias de notificaciones push aquí",
        "CONVERSATION_ASSIGNMENT": "Enviar notificaciones push cuando se me ha asignado una conversación",
        "CONVERSATION_CREATION": "Enviar notificaciones push cuando se crea una nueva conversación",
        "CONVERSATION_MENTION": "Enviar notificaciones push cuando sea mencionado en una conversación",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Enviar notificaciones push cuando un nuevo mensaja es creadao en una conversación asignada",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Enviar notificaciones push cuando se crea un nuevo mensaje en una conversación participante",
        "HAS_ENABLED_PUSH": "Ha habilitado notificaciones push para este navegador.",
        "REQUEST_PUSH": "Habilitar notificaciones push",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Imagen de perfil"
      },
      "NAME": {
        "LABEL": "Su nombre completo",
        "ERROR": "Introduce un nombre válido por favor",
        "PLACEHOLDER": "Introduzca su nombre completo por favor"
      },
      "DISPLAY_NAME": {
        "LABEL": "Nombre a mostrar",
        "ERROR": "Introduzca un nombre válido por favor",
        "PLACEHOLDER": "Introduzca un nombre a mostrar por favor, esto se mostrará en las conversaciones"
      },
      "AVAILABILITY": {
        "LABEL": "Disponibilidad",
        "STATUS": {
          "ONLINE": "En línea",
          "BUSY": "Ocupado",
          "OFFLINE": "Desconectado"
        },
        "SET_AVAILABILITY_SUCCESS": "La disponibilidad se ha establecido con éxito",
        "SET_AVAILABILITY_ERROR": "No se pudo establecer la disponibilidad, inténtelo de nuevo",
        "IMPERSONATING_ERROR": "No se puede cambiar la disponibilidad al suplantar a un usuario"
      },
      "EMAIL": {
        "LABEL": "Tu dirección de correo",
        "ERROR": "Por favor, introduzca una dirección de correo válida",
        "PLACEHOLDER": "Por favor, introduzca su dirección de correo electrónico, esto se mostrará en las conversaciones"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Contraseña actual",
        "ERROR": "Por favor, introduzca su contraseña actual",
        "PLACEHOLDER": "Por favor, introduzca su contraseña actual"
      },
      "PASSWORD": {
        "LABEL": "Nueva contraseña",
        "ERROR": "Por favor, introduzca una contraseña de longitud 6 o más",
        "PLACEHOLDER": "Por favor, introduzca una nueva contraseña"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Confirmar nueva contraseña",
        "ERROR": "Confirmar contraseña debe coincidir con la contraseña",
        "PLACEHOLDER": "Por favor, vuelva a introducir su nueva contraseña"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Cambiar",
    "CHANGE_ACCOUNTS": "Cambiar de cuenta",
    "SWITCH_ACCOUNT": "Cambiar de cuenta",
    "CONTACT_SUPPORT": "Contactar a soporte",
    "SELECTOR_SUBTITLE": "Seleccione una cuenta de la siguiente lista",
    "PROFILE_SETTINGS": "Ajustes del perfil",
    "YEAR_IN_REVIEW": "Resumen del año",
    "KEYBOARD_SHORTCUTS": "Atajos de teclado",
    "APPEARANCE": "Cambiar apariencia",
    "SUPER_ADMIN_CONSOLE": "Consola SuperAdmin",
    "DOCS": "Leer la documentación",
    "CHANGELOG": "Notas de versión",
    "LOGOUT": "Cerrar sesión"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "días de prueba restantes.",
    "TRAIL_BUTTON": "Comprar ahora",
    "DELETED_USER": "Usuario eliminado",
    "EMAIL_VERIFICATION_PENDING": "Parece que aún no has verificado tu dirección de correo electrónico. Por favor, revisa tu bandeja de entrada para ver el correo electrónico de verificación.",
    "RESEND_VERIFICATION_MAIL": "Reenviar correo de verificación",
    "EMAIL_VERIFICATION_SENT": "El correo electrónico de verificación ha sido enviado. Por favor, comprueba tu bandeja de entrada.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Cuenta suspendida",
      "MESSAGE": "Tu cuenta ha sido suspendida debido a actividades que pueden violar nuestras políticas. Si crees que esto es un error, ponte en contacto con nuestro equipo de soporte."
    },
    "NO_ACCOUNTS": {
      "TITLE": "No account found",
      "MESSAGE_CLOUD": "You are not part of any accounts right now. If you think this is a mistake, please reach out to our support team.",
      "MESSAGE_SELF_HOSTED": "You are not part of any accounts right now. Please reach out to your administrator.",
      "LOGOUT": "Cerrar sesión"
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Copiar",
      "CODEPEN": "Abrir en Code Pen",
      "COPY_SUCCESSFUL": "Código copiado al portapapeles con éxito"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Mostrar más",
      "SHOW_LESS": "Mostrar menos"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Descargar",
      "UPLOADING": "Subiendo...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Esta historia ya no está disponible.",
      "INSTAGRAM_STORY_REPLY": "Respondió a su historia:"
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Ver en el mapa"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Enviar"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Esta imagen ya no está disponible.",
      "LOADING_FAILED": "Error al cargar"
    }
  },
  "CONFIRM_EMAIL": "Verificando...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Añadir bandeja de entrada"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No hay elementos",
    "CURRENTLY_VIEWING_ACCOUNT": "Visualizando:",
    "SWITCH": "Cambiar",
    "INBOX_VIEW": "Vista del buzón",
    "CONVERSATIONS": "Conversaciones",
    "INBOX": "Mi bandeja de entrada",
    "ALL_CONVERSATIONS": "Todas las conversaciones",
    "MENTIONED_CONVERSATIONS": "Menciones",
    "PARTICIPATING_CONVERSATIONS": "Participar",
    "UNATTENDED_CONVERSATIONS": "Desatendido",
    "REPORTS": "Informes",
    "SETTINGS": "Ajustes",
    "CONTACTS": "Contactos",
    "ACTIVE": "Activo",
    "COMPANIES": "Empresas",
    "ALL_COMPANIES": "All Companies",
    "CAPTAIN": "Capitán",
    "CAPTAIN_ASSISTANTS": "Asistentes",
    "CAPTAIN_OVERVIEW": "Resumen",
    "CAPTAIN_DOCUMENTS": "Documentos",
    "CAPTAIN_RESPONSES": "Preguntas frecuentes",
    "CAPTAIN_TOOLS": "Tools",
    "CAPTAIN_SCENARIOS": "Scenarios",
    "CAPTAIN_PLAYGROUND": "Playground",
    "CAPTAIN_INBOXES": "Entradas",
    "CAPTAIN_SETTINGS": "Ajustes",
    "HOME": "Inicio",
    "AGENTS": "Agentes",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Auditoría de registros",
    "INBOXES": "Entradas",
    "NOTIFICATIONS": "Notificaciones",
    "CANNED_RESPONSES": "Respuestas predefinidas",
    "INTEGRATIONS": "Integraciones",
    "DATA": "Datos",
    "PROFILE_SETTINGS": "Ajustes del perfil",
    "ACCOUNT_SETTINGS": "Configuración de la cuenta",
    "APPLICATIONS": "Aplicaciones",
    "LABELS": "Etiquetas",
    "CUSTOM_ATTRIBUTES": "Atributos personalizados",
    "AUTOMATION": "Automatización",
    "MACROS": "Macros",
    "TEAMS": "Equipos",
    "BILLING": "Facturación",
    "CUSTOM_VIEWS_FOLDER": "Carpetas",
    "CUSTOM_VIEWS_SEGMENTS": "Segmentos",
    "ALL_CONTACTS": "Todos los contactos",
    "TAGGED_WITH": "Etiquetado con",
    "NEW_LABEL": "Nueva etiqueta",
    "NEW_TEAM": "Nuevo equipo",
    "NEW_INBOX": "Nuevo buzón",
    "REPORTS_CONVERSATION": "Conversaciones",
    "CSAT": "Encuestas de Satisfacción",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "WHATSAPP": "WhatsApp",
    "CAMPAIGNS": "Campañas",
    "ONGOING": "En Curso",
    "ONE_OFF": "One Off",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agentes",
    "REPORTS_LABEL": "Etiquetas",
    "REPORTS_INBOX": "Bandeja de entrada",
    "REPORTS_TEAM": "Equipo",
    "AGENT_ASSIGNMENT": "Agent Assignment",
    "SET_AVAILABILITY_TITLE": "Ponte como",
    "SET_YOUR_AVAILABILITY": "Establecer su disponibilidad",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Roles personalizados",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Resumen",
    "REAUTHORIZE": "Su sesión ha expirado, por favor, vuelva a conectarse para continuar recibiendo y enviando mensajes",
    "HELP_CENTER": {
      "TITLE": "Centro de ayuda",
      "ARTICLES": "Artículos",
      "CATEGORIES": "Categorías",
      "LOCALES": "Idiomas",
      "SETTINGS": "Ajustes"
    },
    "CHANNELS": "Canales",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Marcar como desconectado automáticamente",
      "INFO_TEXT": "Permite que el sistema te marque automáticamente sin conexión cuando no estás usando la aplicación o el tablero.",
      "INFO_SHORT": "Marcar automáticamente sin conexión cuando no está usando la aplicación."
    },
    "SORT_TOOLTIP": "Ordenar",
    "SORT_BY": "Ordenar por",
    "SORT_GROUPS": {
      "CREATED": "Ordenar por fecha de creación",
      "ALPHABETICAL": "Ordenar en orden alfabético",
      "UNREAD_COUNT": "Ordenar por número de no leídos"
    },
    "SORT_OPTIONS": {
      "CREATED_DESC": "Más nuevo primero",
      "CREATED_ASC": "Lo más antiguo primero",
      "ALPHABETICAL_ASC": "Ascendente (A - Z)",
      "ALPHABETICAL_DESC": "Descendente (Z - A)",
      "UNREAD_COUNT_DESC": "Más alto primero",
      "UNREAD_COUNT_ASC": "Más bajo primero"
    },
    "DOCS": "Leer documentos",
    "SECURITY": "Security",
    "CAPTAIN_AI": "Capitán",
    "CONVERSATION_WORKFLOW": "Conversation Workflow"
  },
  "DATA_IMPORTS": {
    "HEADER": "Datos",
    "DESCRIPTION": "Trae tus contactos y conversaciones pasadas a esta cuenta desde otra herramienta de soporte. Cada importación se ejecuta en segundo plano, así que puedes seguir trabajando mientras termina, rastrea su progreso y revisa cualquier cosa que se haya omitido a lo largo del camino.",
    "LOADING": "Obteniendo importaciones",
    "DEFAULT_IMPORT_NAME": "Importar Intercom",
    "TABS": {
      "IMPORT": "Importar",
      "EXPORT": "Exportar"
    },
    "TYPES": {
      "CONTACTS": "Contactos",
      "CONVERSATIONS": "Conversaciones",
      "MESSAGES": "Mensajes"
    },
    "DRAWER": {
      "TITLE": "Nueva importación",
      "SOURCE": "Fuente",
      "NAME": "Importar nombre",
      "NAME_PLACEHOLDER": "Migración de julio de Intercom",
      "ACCESS_KEY": "Clave de acceso Intercom",
      "ACCESS_KEY_PLACEHOLDER": "Pegue su clave de acceso Intercom",
      "DATA_TYPES": "Datos a importar",
      "VALIDATING": "Validando clave de acceso...",
      "VALID_KEY": "Clave de acceso validada.",
      "INVALID_KEY": "No se pudo validar esta clave de acceso.",
      "ACTIVE_IMPORT": "Espere a que finalice la importación activa antes de comenzar otra.",
      "CANCEL": "Cancelar",
      "IMPORT": "Importar"
    },
    "EXPORT": {
      "TITLE": "Las exportaciones están en camino",
      "DESCRIPTION": "Exporta tus contactos y conversaciones desde esta cuenta. Este flujo de trabajo estará disponible pronto.",
      "COMING_SOON": "Próximamente"
    },
    "TABLE": {
      "TITLE": "Importaciones recientes",
      "EMPTY": "Aún no hay importaciones",
      "EMPTY_DESCRIPTION": "Iniciar una importación para traer su historial de clientes existente a esta cuenta.",
      "NEW_IMPORT": "Importar",
      "COUNT": "{count} importaciones",
      "UNNAMED": "Importar sin título",
      "IMPORTED_COUNT": "{count} importados",
      "VIEW": "Ver importación",
      "NAME": "Nombre",
      "TYPE": "Tipo",
      "STATUS": "Estado",
      "IMPORTED": "Importado",
      "CREATED": "Creado",
      "ABANDON": "Abandonar"
    },
    "DETAIL": {
      "BACK": "Volver a las importaciones",
      "ERRORS": "Errores",
      "SKIP_LOGS": "Saltar registros",
      "SOURCE": "Fuente",
      "IMPORT_TYPES": "Importar tipos",
      "CREATED": "Creado",
      "DURATION": "Duración",
      "INITIATED_BY": "Iniciado por",
      "PROGRESS": "Progreso de importación",
      "PROGRESS_WITH_TOTAL": "{imported} de {total} importados",
      "PROGRESS_WITHOUT_TOTAL": "{imported} importados",
      "PROGRESS_OF_TOTAL": "de {total} importados",
      "PROGRESS_IMPORTED": "importado",
      "LAST_UPDATED_TOOLTIP": "Última actualización {time}",
      "NO_SKIP_LOGS": "No se han grabado registros saltados o fallidos.",
      "DOWNLOAD_SKIP_LOGS": "Descargar CSV",
      "DOWNLOAD_ERROR_LOGS": "Descargar CSV",
      "ALL_SKIP_LOGS": "Todos",
      "KIND": "Clase",
      "NO_ERRORS": "No se han registrado errores.",
      "ERROR_CODE": "Código",
      "SOURCE_OBJECT": "Objeto origen",
      "MESSAGE": "Mensaje"
    },
    "MONITOR": {
      "LIVE": "Actualizaciones en vivo cada {seconds}s",
      "LAST_UPDATED": "Última actualización {time}",
      "REFRESH": "Actualizar",
      "REFRESHING": "Actualizando",
      "STAGES": {
        "unknown": "Esperando actualización",
        "queued": "En cola",
        "contacts": "Importando contactos",
        "conversations": "Importando conversaciones",
        "finalizing": "Finalizando importación",
        "completed": "Completado",
        "completed_with_errors": "Completado con errores",
        "failed": "Fallido",
        "abandoned": "Abandonado"
      }
    },
    "ALERTS": {
      "IMPORT_STARTED": "La importación de Intercom ha comenzado.",
      "IMPORT_ABANDONED": "La importación de Intercom ha sido abandonada.",
      "IMPORT_FAILED": "No se pudo iniciar la importación de Intercom."
    }
  },
  "CAPTAIN_SETTINGS": {
    "TITLE": "Captain Settings",
    "DESCRIPTION": "Configure your AI models and features for Captain. Captain follows a credit based billing, you will be charged credits for every action Captain takes based on the model selected.",
    "LOADING": "Loading Captain configuration...",
    "LINK_TEXT": "Learn more about Captain Credits",
    "NOT_ENABLED": "Captain is not enabled for your account. Please upgrade your plan to access Captain features.",
    "MODEL_CONFIG": {
      "TITLE": "Model Configuration",
      "DESCRIPTION": "Select AI models for different features.",
      "SELECT_MODEL": "Select model",
      "CREDITS_PER_MESSAGE": "{credits} credit/message",
      "COMING_SOON": "Coming soon",
      "EDITOR": {
        "TITLE": "Editor Features",
        "DESCRIPTION": "Powers smart compose, grammar corrections, tone adjustments, and content enhancement in your message editor."
      },
      "ASSISTANT": {
        "TITLE": "Assistant",
        "DESCRIPTION": "Handles automated responses, conversation summaries, and intelligent reply suggestions for customer interactions."
      },
      "COPILOT": {
        "TITLE": "Co-pilot",
        "DESCRIPTION": "Provides real-time contextual suggestions, knowledge base recommendations, and proactive insights during conversations."
      }
    },
    "FEATURES": {
      "TITLE": "Características",
      "DESCRIPTION": "Enable or disable AI-powered features.",
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Audio Transcription",
        "DESCRIPTION": "Automatically convert voice messages and call recordings into searchable text transcripts.",
        "MODEL_TITLE": "Modelo de Transcripción de Audio",
        "MODEL_DESCRIPTION": "Seleccione el modelo de IA a utilizar para convertir mensajes de audio en transcripciones de texto"
      },
      "HELP_CENTER_SEARCH": {
        "TITLE": "Help Center Search Indexing",
        "DESCRIPTION": "Use AI for context aware search inside your help center articles."
      },
      "LABEL_SUGGESTION": {
        "TITLE": "Label Suggestion",
        "DESCRIPTION": "Automatically suggest relevant labels and tags for conversations based on content analysis and context.",
        "MODEL_TITLE": "Label Suggestion Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for analyzing conversations and suggesting appropriate labels"
      }
    },
    "API": {
      "SUCCESS": "Captain settings updated successfully.",
      "ERROR": "Failed to update Captain settings. Please try again."
    }
  },
  "BILLING_SETTINGS": {
    "TITLE": "Facturación",
    "DESCRIPTION": "Gestiona tu suscripción aquí, mejora tu plan y consigue más para tu equipo.",
    "CURRENT_PLAN": {
      "TITLE": "Plan actual",
      "PLAN_NOTE": "Actualmente está suscrito al plan **{plan}** con **{quantity}** licencias",
      "SEAT_COUNT": "Número de asientos",
      "RENEWS_ON": "Renueva el",
      "CURRENCY": "Moneda"
    },
    "CURRENCY": {
      "SELECT": {
        "TITLE": "Elige tu moneda de facturación",
        "DESCRIPTION": "Selecciona la moneda en la que te gustaría ser facturado. Esto no se puede cambiar una vez creada tu suscripción."
      },
      "OPTIONS": {
        "USD": "Dólar US (USD)",
        "BRL": "Real Brasileño (BRL)"
      }
    },
    "VIEW_PRICING": "Ver precios",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Administre su suscripción",
      "DESCRIPTION": "Vea sus facturas anteriores, edite sus datos de facturación o cancele su suscripción.",
      "BUTTON_TXT": "Ir al portal de facturación"
    },
    "CAPTAIN": {
      "TITLE": "Capitán",
      "DESCRIPTION": "Gestione el uso y los créditos para Captain AI.",
      "BUTTON_TXT": "Comprar más créditos",
      "DOCUMENTS": "Documentos",
      "RESPONSES": "Respuestas",
      "UPGRADE": "Captain no está disponible en el plan gratuito, actualice su suscripción ahora para tener acceso a asistentes, copilot y más.",
      "REFRESH_CREDITS": "Actualizar"
    },
    "CHAT_WITH_US": {
      "TITLE": "¿Necesitas ayuda?",
      "DESCRIPTION": "¿Tienes a algún problema en la facturación? Estamos aquí para ayudarte.",
      "BUTTON_TXT": "Chatea con nosotros"
    },
    "NO_BILLING_USER": "Tu cuenta de facturación está siendo configurada. Por favor, actualiza la página e inténtalo de nuevo.",
    "TOPUP": {
      "BUY_CREDITS": "Comprar más créditos",
      "MODAL_TITLE": "Buy AI Credits",
      "MODAL_DESCRIPTION": "Purchase additional credits for Captain AI.",
      "CREDITS": "CREDITS",
      "ONE_TIME": "one-time",
      "POPULAR": "Most Popular",
      "NOTE_TITLE": "Nota:",
      "NOTE_DESCRIPTION": "Credits are added immediately and expire in 6 months. An active subscription is required to use credits. Purchased credits are consumed after your monthly plan credits.",
      "CANCEL": "Cancelar",
      "PURCHASE": "Purchase Credits",
      "LOADING": "Loading options...",
      "FETCH_ERROR": "Failed to load credit options. Please try again.",
      "RETRY": "Reintentar",
      "PURCHASE_ERROR": "Failed to process purchase. Please try again.",
      "PURCHASE_SUCCESS": "Successfully added {credits} credits to your account",
      "CONFIRM": {
        "TITLE": "Confirm Purchase",
        "DESCRIPTION": "You are about to purchase {credits} credits for {amount}.",
        "INSTANT_DEDUCTION_NOTE": "Your saved card will be charged immediately upon confirmation.",
        "GO_BACK": "Volver",
        "CONFIRM_PURCHASE": "Confirm Purchase"
      }
    }
  },
  "SECURITY_SETTINGS": {
    "TITLE": "Security",
    "DESCRIPTION": "Manage your account security settings.",
    "LINK_TEXT": "Learn more about SAML SSO",
    "SAML_DISABLED_MESSAGE": "SAML SSO is currently disabled. Please contact your administrator to enable this feature.",
    "SAML": {
      "TITLE": "SAML SSO",
      "NOTE": "Configure SAML single sign-on for your account. Users will authenticate through your identity provider instead of using email/password.",
      "ACS_URL": {
        "LABEL": "ACS URL",
        "TOOLTIP": "Assertion Consumer Service URL - Configure this URL in your IdP as the destination for SAML responses"
      },
      "SSO_URL": {
        "LABEL": "SSO URL",
        "HELP": "The URL where SAML authentication requests will be sent",
        "PLACEHOLDER": "https://your-idp.com/saml/sso"
      },
      "CERTIFICATE": {
        "LABEL": "Signing certificate in PEM format",
        "HELP": "The public certificate from your identity provider used to verify SAML responses",
        "PLACEHOLDER": "-----BEGIN CERTIFICATE-----\nMIIC..."
      },
      "FINGERPRINT": {
        "LABEL": "Fingerprint",
        "TOOLTIP": "SHA-1 fingerprint of the certificate - Use this to verify the certificate in your IdP configuration"
      },
      "COPY_SUCCESS": "Código copiado al portapapeles con éxito",
      "SP_ENTITY_ID": {
        "LABEL": "SP Entity ID",
        "HELP": "Unique identifier for this application as a service provider (auto-generated).",
        "TOOLTIP": "Unique identifier for Chatwoot as the Service Provider - Configure this in your IdP settings"
      },
      "IDP_ENTITY_ID": {
        "LABEL": "Identity Provider Entity ID",
        "HELP": "Unique identifier for your identity provider (usually found in IdP configuration)",
        "PLACEHOLDER": "https://your-idp.com/saml"
      },
      "UPDATE_BUTTON": "Update SAML Settings",
      "API": {
        "SUCCESS": "SAML settings updated successfully",
        "ERROR": "Failed to update SAML settings",
        "ERROR_LOADING": "Failed to load SAML settings",
        "DISABLED": "SAML settings disabled successfully"
      },
      "VALIDATION": {
        "REQUIRED_FIELDS": "SSO URL, Identity Provider Entity ID, and Certificate are required fields",
        "SSO_URL_ERROR": "Please enter a valid SSO URL",
        "CERTIFICATE_ERROR": "Certificate is required",
        "IDP_ENTITY_ID_ERROR": "Identity Provider Entity ID is required"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade to an Enterprise plan to access SAML single sign-on and other advanced security features.",
        "ASK_ADMIN": "Por favor, comuníquese con su administrador para la actualización."
      },
      "PAYWALL": {
        "TITLE": "Upgrade to enable SAML SSO",
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to get access to SAML single sign-on and other advanced features.",
        "UPGRADE_NOW": "Actualizar ahora",
        "CANCEL_ANYTIME": "Puede cambiar o cancelar su plan en cualquier momento"
      },
      "ATTRIBUTE_MAPPING": {
        "TITLE": "SAML Attribute Setup",
        "DESCRIPTION": "The following attribute mappings must be configured in your identity provider"
      },
      "INFO_SECTION": {
        "TITLE": "Service Provider Information",
        "TOOLTIP": "Copy these values and configure them in your Identity Provider to establish the SAML connection"
      }
    }
  },
  "CONVERSATION_WORKFLOW": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Conversation Workflows",
        "DESCRIPTION": "Configure rules and required fields for conversation resolution."
      }
    },
    "REQUIRED_ATTRIBUTES": {
      "TITLE": "Attributes required on resolution",
      "DESCRIPTION": "When resolving a conversation, agents will be prompted to fill these attributes if they haven't yet.",
      "NO_ATTRIBUTES": "No attributes added yet",
      "ADD": {
        "TITLE": "Add Attributes",
        "SEARCH_PLACEHOLDER": "Buscar atributos"
      },
      "SAVE": {
        "SUCCESS": "Required attributes updated",
        "ERROR": "Could not update required attributes, please try again"
      },
      "MODAL": {
        "TITLE": "Resolver conversación",
        "DESCRIPTION": "Please fill in the following custom attributes before resolving this conversation",
        "ACTIONS": {
          "RESOLVE": "Resolver conversación",
          "CANCEL": "Cancelar"
        },
        "PLACEHOLDERS": {
          "TEXT": "Write a note...",
          "NUMBER": "Enter a number",
          "LINK": "Add a link",
          "DATE": "Pick a date",
          "LIST": "Selecciona una opción"
        },
        "CHECKBOX": {
          "YES": "Si",
          "NO": "No"
        }
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use required attributes",
        "AVAILABLE_ON": "The required conversation attributes feature is available on the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to prompt agents to fill required attributes before conversation resolution.",
        "UPGRADE_NOW": "Actualizar ahora",
        "CANCEL_ANYTIME": "Puede cambiar o cancelar su plan en cualquier momento"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The required conversation attributes feature is available on the paid plans.",
        "UPGRADE_PROMPT": "Upgrade to a paid plan to enforce required attributes before conversation resolution.",
        "ASK_ADMIN": "Por favor, comuníquese con su administrador para la actualización."
      }
    }
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "¡Oh oh! No hemos podido encontrar ninguna cuenta de \"Chatwoot\". Por favor, crea una nueva cuenta para continuar.",
    "NEW_ACCOUNT": "Nueva cuenta",
    "SELECTOR_SUBTITLE": "Crear nueva cuenta",
    "API": {
      "SUCCESS_MESSAGE": "Cuenta creada con éxito",
      "EXIST_MESSAGE": "La cuenta ya existe",
      "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtelo de nuevo más tarde"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Empresa",
        "PLACEHOLDER": "Empresas de Wayne"
      },
      "SUBMIT": "Enviar",
      "CANCEL": "Cancelar"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Ver todos los accesos rápidos",
    "TITLE": {
      "OPEN_CONVERSATION": "Abrir conversación",
      "RESOLVE_AND_NEXT": "Resolver y pasar al siguiente",
      "NAVIGATE_DROPDOWN": "Navegar elementos desplegables",
      "RESOLVE_CONVERSATION": "Resolver conversación",
      "GO_TO_CONVERSATION_DASHBOARD": "Ir al panel de conversaciones",
      "ADD_ATTACHMENT": "Añadir archivo adjunto",
      "GO_TO_CONTACTS_DASHBOARD": "Ir al panel de contactos",
      "TOGGLE_SIDEBAR": "Cambiar barra lateral",
      "GO_TO_REPORTS_SIDEBAR": "Ir a la barra lateral de informes",
      "MOVE_TO_NEXT_TAB": "Mover a la siguiente pestaña en la lista de conversaciones",
      "GO_TO_SETTINGS": "Ir a Ajustes",
      "SWITCH_TO_PRIVATE_NOTE": "Cambiar a nota privada",
      "SWITCH_TO_REPLY": "Cambiar a respuesta",
      "TOGGLE_SNOOZE_DROPDOWN": "Cambiar el menú desplegable"
    }
  },
  "ASSIGNMENT_POLICY": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Agent assignment",
        "DESCRIPTION": "Define policies to effectively manage workload and route conversations based on the needs of inboxes and agents. Learn more here"
      },
      "ASSIGNMENT_POLICY": {
        "TITLE": "Assignment policy",
        "DESCRIPTION": "Manage how conversations get assigned in inboxes.",
        "FEATURES": [
          "Assign by conversations evenly or by available capacity",
          "Add fair distribution rules to avoid overloading any agent",
          "Add inboxes to a policy - one policy per inbox"
        ]
      },
      "AGENT_CAPACITY_POLICY": {
        "TITLE": "Agent capacity policy",
        "DESCRIPTION": "Manage workload for agents.",
        "FEATURES": [
          "Define maximum conversations per inbox",
          "Create exceptions based on labels and time",
          "Add agents to a policy - one policy per agent"
        ]
      }
    },
    "AGENT_ASSIGNMENT_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Assignment policy",
          "CREATE_POLICY": "New policy"
        },
        "CARD": {
          "ORDER": "Order",
          "PRIORITY": "Prioridad",
          "ACTIVE": "Activo",
          "INACTIVE": "Inactive",
          "POPOVER": "Added inboxes",
          "EDIT": "Editar"
        },
        "NO_RECORDS_FOUND": "No assignment policies found"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Create assignment policy"
        },
        "CREATE_BUTTON": "Create policy",
        "API": {
          "SUCCESS_MESSAGE": "Assignment policy created successfully",
          "ERROR_MESSAGE": "Failed to create assignment policy",
          "INBOX_LINKED": "Inbox has been linked to the policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit assignment policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_INBOX_DIALOG": {
          "TITLE": "Add inbox",
          "DESCRIPTION": "{inboxName} inbox is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "Cancelar"
        },
        "INBOX_LINK_PROMPT": {
          "TITLE": "Link inbox to policy",
          "DESCRIPTION": "Would you like to link this inbox to the assignment policy?",
          "LINK_BUTTON": "Link inbox",
          "CANCEL_BUTTON": "Skip"
        },
        "API": {
          "SUCCESS_MESSAGE": "Assignment policy updated successfully",
          "ERROR_MESSAGE": "Failed to update assignment policy"
        },
        "INBOX_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox added to policy successfully",
            "ERROR_MESSAGE": "Failed to add inbox to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Inbox removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove inbox from policy"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "Descripción:",
          "PLACEHOLDER": "Introducir descripción"
        },
        "STATUS": {
          "LABEL": "Estado:",
          "PLACEHOLDER": "Seleccionar estado",
          "ACTIVE": "Policy is active",
          "INACTIVE": "Policy is inactive"
        },
        "ASSIGNMENT_ORDER": {
          "LABEL": "Assignment order",
          "ROUND_ROBIN": {
            "LABEL": "Round robin",
            "DESCRIPTION": "Assign conversations evenly among agents."
          },
          "BALANCED": {
            "LABEL": "Balanced",
            "DESCRIPTION": "Assign conversations based on available capacity.",
            "PREMIUM_MESSAGE": "Upgrade to access balanced assignment and agent capacity management.",
            "PREMIUM_BADGE": "Premium"
          }
        },
        "ASSIGNMENT_PRIORITY": {
          "LABEL": "Assignment priority",
          "EARLIEST_CREATED": {
            "LABEL": "Earliest created",
            "DESCRIPTION": "The conversation that was created first gets assigned first."
          },
          "LONGEST_WAITING": {
            "LABEL": "Longest waiting",
            "DESCRIPTION": "The conversation waiting the longest gets assigned first."
          }
        },
        "FAIR_DISTRIBUTION": {
          "LABEL": "Fair distribution policy",
          "DESCRIPTION": "Limita las conversaciones por agente dentro de una ventana de tiempo para evitar sobrecargas. Por defecto es 100 por hora.",
          "INPUT_MAX": "Assign max",
          "DURATION": "Conversations per agent in every"
        },
        "EXCLUDE_OLDER_THAN": {
          "LABEL": "Saltar conversaciones obsoletas",
          "DESCRIPTION": "Saltar conversaciones no asignadas más antiguas que esto. Por defecto es 7 días; borrar para desactivar."
        },
        "INBOXES": {
          "LABEL": "Added inboxes",
          "DESCRIPTION": "Add inboxes for which this policy will be applicable.",
          "ADD_BUTTON": "Add inbox",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Search and select inboxes to add",
            "ADD_BUTTON": "Añadir"
          },
          "EMPTY_STATE": "No inboxes added to this policy, add an inbox to get started",
          "API": {
            "SUCCESS_MESSAGE": "Inbox successfully added to policy",
            "ERROR_MESSAGE": "Failed to add inbox to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Assignment policy deleted successfully",
        "ERROR_MESSAGE": "Failed to delete assignment policy"
      }
    },
    "AGENT_CAPACITY_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Agent capacity",
          "CREATE_POLICY": "New policy"
        },
        "CARD": {
          "POPOVER": "Added agents",
          "EDIT": "Editar"
        },
        "NO_RECORDS_FOUND": "No agent capacity policies found"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Create agent capacity policy"
        },
        "CREATE_BUTTON": "Create policy",
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy created successfully",
          "ERROR_MESSAGE": "Failed to create agent capacity policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit agent capacity policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_AGENT_DIALOG": {
          "TITLE": "Add agent",
          "DESCRIPTION": "{agentName} is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "Cancelar"
        },
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy updated successfully",
          "ERROR_MESSAGE": "Failed to update agent capacity policy"
        },
        "AGENT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Agent added to policy successfully",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Agent removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove agent from policy"
          }
        },
        "INBOX_LIMIT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox limit added successfully",
            "ERROR_MESSAGE": "Failed to add inbox limit"
          },
          "UPDATE": {
            "SUCCESS_MESSAGE": "Inbox limit updated successfully",
            "ERROR_MESSAGE": "Failed to update inbox limit"
          },
          "DELETE": {
            "SUCCESS_MESSAGE": "Inbox limit deleted successfully",
            "ERROR_MESSAGE": "Failed to delete inbox limit"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "Descripción:",
          "PLACEHOLDER": "Introducir descripción"
        },
        "INBOX_CAPACITY_LIMIT": {
          "LABEL": "Inbox capacity limits",
          "ADD_BUTTON": "Add inbox",
          "FIELD": {
            "SELECT_INBOX": "Select inbox",
            "MAX_CONVERSATIONS": "Max conversations",
            "SET_LIMIT": "Set limit"
          },
          "EMPTY_STATE": "No inbox limit set"
        },
        "EXCLUSION_RULES": {
          "LABEL": "Exclusion rules",
          "DESCRIPTION": "Conversations that satisfy the following conditions would not count towards agent capacity",
          "TAGS": {
            "LABEL": "Exclude conversations tagged with specific labels",
            "ADD_TAG": "add tag",
            "DROPDOWN": {
              "SEARCH_PLACEHOLDER": "Search and select tags to add"
            },
            "EMPTY_STATE": "No tags added to this policy."
          },
          "DURATION": {
            "LABEL": "Exclude conversations older than a specified duration",
            "PLACEHOLDER": "Set time"
          }
        },
        "USERS": {
          "LABEL": "Assigned agents",
          "DESCRIPTION": "Add agents for which this policy will be applicable.",
          "ADD_BUTTON": "Add agent",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Search and select agents to add",
            "ADD_BUTTON": "Añadir"
          },
          "EMPTY_STATE": "No agents added",
          "API": {
            "SUCCESS_MESSAGE": "Agent successfully added to policy",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Agent capacity policy deleted successfully",
        "ERROR_MESSAGE": "Failed to delete agent capacity policy"
      }
    },
    "DELETE_POLICY": {
      "TITLE": "Delete policy",
      "DESCRIPTION": "Are you sure you want to delete this policy? This action cannot be undone.",
      "CONFIRM_BUTTON_LABEL": "Eliminar",
      "CANCEL_BUTTON_LABEL": "Cancelar"
    }
  }
}
